// import * as THREE from 'three';
import EventEmitter from "../../utils/EventEmitter";
import { UIPanel, UIImage, UITooltip } from "../ui.lib";

//Icon
import ModelIcon from '../../../../assets/svgs/scenes/menu/model.svg';


class MenubarModel extends EventEmitter {
    constructor(editor) {
        super();

        this.editor = editor;
        this.strings = this.editor.strings;
        this.dom = null;
        this.name = '3D Models';
        this.isActive = false;
        this.editor.on('toggleMenuActive', this.onToggleMenuActive);

        this.initUI();
    }

    initUI = () => {

        this.uiCont = new UIPanel();
        this.uiCont.addClass('wsMenuContainer');
        this.uiCont.setId('wsMenuModel');
        
        this.uiText = new UITooltip(this.strings.getKey('menubar/model'));
        this.uiImg = new UIImage(ModelIcon, '28px', '28px', this.strings.getKey('menubar/model'));

        this.uiCont.addChild(this.uiImg);
        this.uiCont.addChild(this.uiText);

        this.uiCont.onClick(() => {
            this.makeActive();
            // fileInput.click();
        })

        this.dom = this.uiCont.dom;
    }

    makeActive = () => {
        if(!this.isActive) {
            this.isActive = true;
            this.uiCont.addClass('wsMenuContainer--active');        
        }
        this.editor.trigger('toggleMenuActive', [this.name]);
        this.editor.trigger('sidebarSceneGraphChanged', [this.name]);
    }

    onToggleMenuActive = (name) => {
        if(name !== this.name) {
            this.isActive = false;
            this.uiCont.removeClass('wsMenuContainer--active');
        }
    }
}

export { MenubarModel };